import React from 'react';
import { ImageProps } from '.';

const SvgZexpressTextKor = ({ size = 60, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 3.75)) || 16} fill='none' viewBox='0 0 60 16' {...props}>
      <path
        fill='#6E52FF'
        d='M13.3 16h-2.246v-3.868H2.316v-1.793H13.3V16ZM44.112 16h-2.14V7.93h-1.439v7.332H38.41V.229h2.123V6.1h1.439V0h2.14v16Z'
      />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M52.7 10.303c3.475 0 5.545 1.038 5.563 2.866C58.245 14.998 56.175 16 52.7 16c-3.51 0-5.598-1.002-5.598-2.83 0-1.83 2.089-2.867 5.598-2.867Zm0 1.706c-2.227 0-3.333.37-3.316 1.16-.017.791 1.089 1.16 3.317 1.16 2.175 0 3.298-.369 3.316-1.16-.018-.79-1.14-1.16-3.316-1.16Z'
        clipRule='evenodd'
      />
      <path fill='#6E52FF' d='M20.03 13.925h8.86v1.794H17.767v-5.187h2.264v3.393Z' />
      <path
        fill='#6E52FF'
        fillRule='evenodd'
        d='M32.83 5.029h2.176V1.424h2.07v10.778h-6.351V1.424h2.105V5.03Zm0 5.38h2.176V6.787H32.83v3.622Z'
        clipRule='evenodd'
      />
      <path
        fill='#6E52FF'
        d='M28.47 11.587h-2.246V.017h2.245v11.57ZM24.539 2.936h-3.21v.229c0 1.916 1.175 3.868 3.807 4.66l-1.14 1.757c-1.79-.562-3.054-1.714-3.773-3.164-.729 1.573-2.027 2.84-3.896 3.463L15.17 8.123c2.65-.862 3.878-2.936 3.878-4.958v-.229h-3.281V1.143h8.773v1.793ZM13.3 9.635h-2.246V0H13.3v9.635ZM53.806 7.63H60v1.794H45.437V7.631h6.158V5.66h2.211v1.97ZM9.37 2.725H6.159c.017 1.873 1.193 3.842 3.807 4.624L8.826 9.09c-1.79-.554-3.053-1.705-3.773-3.165-.728 1.583-2.026 2.84-3.895 3.464L0 7.649c2.632-.853 3.86-2.928 3.878-4.924H.597V.932H9.37v1.793Z'
      />
      <path
        fill='#6E52FF'
        d='M53.841.791c0 1.864 1.79 3.64 5.387 4.08l-.86 1.74c-2.693-.404-4.676-1.539-5.685-3.147-1.026 1.608-3.01 2.751-5.702 3.147l-.79-1.74c3.527-.44 5.37-2.269 5.37-4.08V.264h2.28V.79Z'
      />
    </svg>
  );
};

export default SvgZexpressTextKor;
